module.exports = __webpack_public_path__ + "static/media/wide-skyscrapper-2017.e13e66c0.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/wide-skyscrapper-2017.png
 ** module id = 458
 ** module chunks = 0
 **/